export const generateKeyForRequiredFromUIM = (parameters: {
	fieldId: string;
	isRequiredFromUIM: boolean;
}): string => {
	const { fieldId, isRequiredFromUIM } = parameters;
	return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
};
